import React from "react";
import {IUserContext} from "./UserContext.interfaces";

export const UserContext = React.createContext<IUserContext>({} as any);